import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
    output,
    signal,
    TemplateRef,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TelXLLoadingComponent, TelXLSearchComponent } from '@dxp/elements';
import {
    IDirectoryListing,
    IDirectoryListingEvent,
    IDirectorySelection,
    IIvrDirectoryEvent,
    IVoiceIVRData,
} from '@dxp/core/models';
import { VoiceIVRService } from '@dxp/core/services';

import { CommonModule } from '@angular/common';
import { ListingMode, MediaType } from '@dxp/core/types';
import { TelXLDirectoryListingItemComponent } from '../item/directory-listing-item.component';

@Component({
    selector: 'telxl-shared-ivr-directory-panel',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        FormsModule,
        TelXLLoadingComponent,
        TelXLDirectoryListingItemComponent,
        TelXLSearchComponent,
    ],
    templateUrl: './ivr-directory-panel.component.html',
    styleUrl: './ivr-directory-panel.component.scss',
})
export class TelXLIvrDirectoryPanelComponent {
    private voiceIVRService = inject(VoiceIVRService);

    customButtonTemplate = input<TemplateRef<any>>();
    selected = input<IDirectorySelection>();
    highlight = input<number>();
    height = input.required<string>();
    mode = input<ListingMode[]>([]);
    displayMediaIcons = input<MediaType[]>([]);
    disabled = input<boolean>(false);
    clicked = output<IIvrDirectoryEvent>();

    readonly #ivrDirectory = computed<IVoiceIVRData[]>(
        () => this.voiceIVRService.ivrs() ?? [],
    );

    readonly searchText = signal<string>('');

    readonly calculateHeight = computed<string>(
        () => `calc(${this.height()} - 100px)`,
    );

    listings = computed<IDirectoryListing[]>(() =>
        this.#ivrDirectory()
            .filter(ivr =>
                this.searchText().length > 0
                    ? ivr.title
                          .toLowerCase()
                          .includes(this.searchText().toLowerCase())
                    : true,
            )
            .map(ivr => {
                return {
                    id: ivr.ID.toString(),
                    name: ivr.title,
                    object: JSON.stringify(ivr),
                };
            }),
    );

    selectedChanged(event: IDirectoryListingEvent) {
        this.clicked.emit({
            type: event.type,
            item: {
                ...(this.#ivrDirectory().find(
                    i => i.ID.toString() === event.item.id,
                ) as IVoiceIVRData),
            },
        });
    }

    searchChanged(searchText: string) {
        this.searchText.set(searchText);
    }
}
